import {
  password_validator_rule_styles_default
} from "./chunk.M7EIY6FI.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  watch
} from "./chunk.WGQU6RP3.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  n
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/password-validator-rule/password-validator-rule.ts
import { t } from "i18next";
var validatorRuleId = 0;
var FadvPasswordRule = class extends s {
  constructor() {
    super(...arguments);
    this.componentId = `password-rule-${++validatorRuleId}`;
    this.ruleLabelId = `${this.componentId}-label`;
    this.ruleValidIcon = `${this.componentId}-valid-icon`;
    this.ruleInvalidIcon = `${this.componentId}-invalid-icon`;
  }
  getLabelledBy() {
    return `${this.valid ? this.ruleValidIcon : this.ruleInvalidIcon} ${this.ruleLabelId}`;
  }
  handleValidChange() {
    emit(this, "password-rule-change", { detail: { valid: this.valid } });
  }
  renderValidIcon() {
    if (!this.valid)
      return w;
    return $`<fadv-icon id=${this.ruleValidIcon} class="password-rule__success-icon password-rule__icon" library="solid" name="fa-circle-check" foreground="success" label=${t("components:passwordValidator.validRule")} ></fadv-icon>`;
  }
  renderInvalidIcon() {
    if (this.valid)
      return w;
    return $`<fadv-icon id=${this.ruleInvalidIcon} class="password-rule__error-icon password-rule__icon" library="solid" foreground="danger" name="fa-circle-xmark" label=${t("components:passwordValidator.invalidRule")} ></fadv-icon>`;
  }
  render() {
    return $`<div tabindex="0" role="listitem" aria-labelledby="${this.getLabelledBy()}" class=${o({
      "password-rule": true,
      "password-rule--valid": !!this.valid,
      "password-rule--invalid": !this.valid
    })} ><div aria-hidden="true" class="password-rule__icons">${this.renderValidIcon()}${this.renderInvalidIcon()}</div><div id=${this.ruleLabelId} class="password-rule__label"><slot>${this.label}</slot></div></div>`;
  }
};
FadvPasswordRule.styles = password_validator_rule_styles_default;
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvPasswordRule.prototype, "valid", 2);
__decorateClass([
  e({ reflect: true })
], FadvPasswordRule.prototype, "label", 2);
__decorateClass([
  watch("valid")
], FadvPasswordRule.prototype, "handleValidChange", 1);
FadvPasswordRule = __decorateClass([
  n("fadv-password-rule")
], FadvPasswordRule);

export {
  FadvPasswordRule
};
